import { Box, Image } from '@customerio/pluma-components/react';
import type { CopilotSession } from '@customerio/hydra-copilot';
import { useCopilotImageThumbnail } from '@/features/copilot/hooks/use-copilot-image-thumbnail';

/**
 * Component to display a single image message with blob URL conversion.
 * Handles both local File objects and remote gs:// URLs.
 */
export function SingleImageMessage({
  source,
  alt,
  readOnly,
  session,
}: {
  source: File | string;
  alt: string;
  readOnly: boolean;
  session?: CopilotSession;
}) {
  const thumbnailUrl = useCopilotImageThumbnail({
    source,
    isImage: true,
    readOnly,
    session,
  });

  if (thumbnailUrl == null) {
    return null;
  }

  return (
    <Box>
      <Image src={thumbnailUrl} alt={alt} />
    </Box>
  );
}
